/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAliasDuplicateBehaviour } from './userAliasDuplicateBehaviour';
import { UserAliasPatternErrorViewModel } from './userAliasPatternErrorViewModel';
import { UserAliasEmptyAttributeBehaviour } from './userAliasEmptyAttributeBehaviour';
import { UserAliasPatternType } from './userAliasPatternType';
import { UserAliasPatternPartViewModel } from './userAliasPatternPartViewModel';


export interface UserAliasPatternViewModel { 
    id?: string | null;
    name?: string | null;
    matchPattern?: string | null;
    replacementPattern?: string | null;
    type?: UserAliasPatternType;
    parts?: Array<UserAliasPatternPartViewModel> | null;
    emptyAttributeBehaviour?: UserAliasEmptyAttributeBehaviour;
    duplicateBehaviour?: UserAliasDuplicateBehaviour;
    status?: string | null;
    errors?: Array<UserAliasPatternErrorViewModel> | null;
}

